import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid } from 'semantic-ui-react';

// Components
import { SearchSelect } from 'components/Pratiche/ClassicMode/AdvancedSearch/components';
import { istitutiDropdownOptions } from 'shared/constants/istitutiOptions';
import {
  STATO_IMPRESA_DROPDOWN_OPTIONS,
  TIPO_GESTIONE_IMPRESA_DROPDOWN_OPTIONS,
  TIPO_OPERAZIONE_IMPRESA_DROPDOWN_OPTIONS,
} from 'shared/constants/processoImprese';
import { FilterInput, FilterSelect } from './filterBarElements';

// Services

const initialState = {
  codicePratica: '',
  ragioneSociale: '',
  partitaiva: '',
  istituto: '',
  tipoGestione: '',
  tipoProdotto: '',
  codiceAgenzia: '',
  collaboratore: '',
  nominativoSenior: '',
  stato: '',
};

class ImpresaFilterBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...initialState,
    };
  }

  onResetClick = () => this.setState({ ...initialState }, () => this.props.onFilter({}));

  onFilter = () => {
    const params = {
      codice: this.state.codicePratica || null,
      ragioneSociale: this.state.ragioneSociale || null,
      partitaiva: this.state.partitaiva || null,
      istituto: this.state.istituto || null,
      tipoGestione: this.state.tipoGestione || null,
      tipoProdotto: this.state.tipoProdotto || null,
      codiceAgenzia: this.state.codiceAgenzia || null,
      collaboratore: this.state.collaboratore || null,
      nominativoSenior: this.state.nominativoSenior || null,
      stato: this.state.stato,
    };

    this.props.onFilter(params);
  };

  handleSearchEnter = (e) => {
    if (e.which === 13) {
      e.preventDefault();
      this.onFilter();
    }
  };

  render() {
    const { onClickNewImpresa } = this.props;
    const {
      codicePratica,
      ragioneSociale,
      partitaiva,
      istituto,
      tipoGestione,
      tipoProdotto,
      codiceAgenzia,
      collaboratore,
      stato,
      nominativoSenior,
    } = this.state;

    return (
      <Grid onKeyDown={this.handleSearchEnter}>
        <Grid.Row>
          <Grid.Column width={4}>
            <FilterInput
              label="Cod. Pratica"
              value={codicePratica}
              onChange={(event) => this.setState({ codicePratica: event.target.value })}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <SearchSelect
              label="Stato"
              value={stato}
              options={STATO_IMPRESA_DROPDOWN_OPTIONS}
              placeholder="Seleziona stato"
              onChange={(_event, data) => this.setState({ stato: data.value })}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <FilterInput
              label="Ragione sociale"
              value={ragioneSociale}
              onChange={(event) => this.setState({ ragioneSociale: event.target.value })}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <FilterInput
              label="Partita IVA"
              value={partitaiva}
              onChange={(event) => this.setState({ partitaiva: event.target.value })}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={4}>
            <SearchSelect
              label="Istituto"
              value={istituto}
              options={istitutiDropdownOptions}
              placeholder="Seleziona istituto"
              onChange={(_event, data) => this.setState({ istituto: data.value })}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <FilterSelect
              label="Tipo gestione"
              value={tipoGestione}
              options={TIPO_GESTIONE_IMPRESA_DROPDOWN_OPTIONS}
              placeholder="Seleziona tipo gestione"
              onChange={(_event, data) => this.setState({ tipoGestione: data.value })}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <FilterSelect
              label="Tipo operazione"
              value={tipoProdotto}
              options={TIPO_OPERAZIONE_IMPRESA_DROPDOWN_OPTIONS}
              placeholder="Seleziona tipo operazione"
              onChange={(_event, data) => this.setState({ tipoProdotto: data.value })}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <FilterInput
              label="Cod. Agenzia"
              value={codiceAgenzia}
              onChange={(event) => this.setState({ codiceAgenzia: event.target.value })}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={4}>
            <FilterInput
              label="Collaboratore"
              value={collaboratore}
              onChange={(event) => this.setState({ collaboratore: event.target.value })}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <FilterInput
              label="Senior"
              value={nominativoSenior}
              onChange={(event) => this.setState({ nominativoSenior: event.target.value })}
            />
          </Grid.Column>
          <Grid.Column width={8} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
            <Button
              content="Reset"
              icon="repeat"
              labelPosition="left"
              onClick={this.onResetClick}
              style={{ marginRight: 15, height: '38px' }}
            />
            <Button
              icon="search"
              labelPosition="left"
              content="Cerca"
              positive
              onClick={this.onFilter}
              style={{ marginRight: 15, height: '38px' }}
            />
            <Button
              icon="plus"
              labelPosition="left"
              primary
              content="Aggiungi"
              onClick={onClickNewImpresa}
              style={{ height: '38px' }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

ImpresaFilterBar.propTypes = {
  /** Function called on add button click */
  onClickNewImpresa: PropTypes.func,
  /** Function called on search button click */
  onFilter: PropTypes.func,
};

export default ImpresaFilterBar;



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/ImpresaFilterBar/index.js